import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import history from '@history';

import { getIsFollowNavigationInProgress, stopFollowingAction } from 'store/presence/actions';
import { selectIsFollowing } from 'store/presence/selectors';

const useStopFollowOnManualNavigation = () => {
  const dispatch = useDispatch();
  const isFollowing = useSelector(selectIsFollowing);

  useEffect(() => {
    if (!isFollowing) {
      return;
    }

    const unlisten = history.listen(() => {
      if (!getIsFollowNavigationInProgress()) {
        dispatch(stopFollowingAction());
      }
    });

    return () => unlisten();
  }, [isFollowing, dispatch]);
};

export default useStopFollowOnManualNavigation;
